export enum TypeDonnee {
  // Format : type de la donnée = nom du endpoint pour l'obtenir
  DOSSIERS = 'dossiers',
  LIENS = 'liens',
  AFFAIRES_LIEES = 'affairesLiees',
  MICROFILMS = 'microfilms',
  PIECES = 'pieces',
  RELATIONS_PROJET = 'relationsProjet',
  ETAPES_FROM_SUIVI = 'etapesFromSuivi',
  ETAPES_ACDEMAT = 'etapesAcDemat',
  REMARQUES = 'remarques',
  STATISTIQUES = 'statistiques',
  SUIVIS = 'suivis',
  SYNOPTIQUE = 'synoptique',
  SYNTHESES = 'syntheses',

  OAC_DEPOT = 'dossieroac/depot',
  OAC_CIRCULATIONS = 'dossieroac/circulations',
  OAC_SYNTHESES = 'dossieroac/syntheses',
  OAC_DECISIONS = 'dossieroac/decisions',
  OAC_MISE_EN_SERVICE = 'dossieroac/miseEnService',
  OAC_CHANTIERS = 'dossieroac/chantiers',
  OAC_PROLONGATIONS = 'dossieroac/prolongations',
  OAC_RECOURS = 'dossieroac/recours',
  OAC_ENQUETES_PUBLIQUES = 'dossieroac/enquetesPubliques',
  OAC_OBSERVATIONS = 'dossieroac/observations'
}
